import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const haveLoadedInstance = (state, instance) => state.some((item) => item.missiveId === instance.missiveId);

/*
 * This, missives, is where we keep track of "Missives" representing the *content* of Outreaches.
 *
 * The structure is
 * [
 *   {
 *     missiveId: <mId>,
 *     creatorId: <cId>,
 *     firmId: <fId>,
 *     missiveType: <['PhoneCall' | 'PersonalSMS' | 'MassEmail' | ...]>,
 *     name: <'whatever'>,
 *     description: <'whatever'>,
 *     content: <'whatever'>,
 *     callRailCallId: <crcId>,
 *   },
 *   {
 *     missiveId: <mId>,
 *     creatorId: <cId>,
 *     ...
 *   },
 *   ...
 * ]
 */

export const missivesSlice = createSlice({
  name: 'missives',
  initialState: initialState,
  reducers: {
    clearMissives: () => {
      return initialState;
    },

    addMissive: (state, action) => {
      const instance = action.payload;
      return haveLoadedInstance(state, instance) ? state : [...state, instance];
    },

    updateMissive: (state, action) => {
      const instance = action.payload;
      if (haveLoadedInstance(state, instance)) {
        const filteredList = state.filter((item) => item.missiveId !== instance.missiveId);
        return [...filteredList, instance];
      } else {
        return [...state, instance];
      }
    },

    deleteMissiveWithId: (state, action) => {
      const idOfInstanceToDelete = action.payload;
      return state.filter((item) => item.missiveId !== idOfInstanceToDelete);
    },
  },
});

export const { clearMissives, addMissive, updateMissive, deleteMissiveWithId } = missivesSlice.actions;

export default missivesSlice.reducer;
